import { Dispatch } from "redux";
import { SET_HEADER_BREADCRUMB, SET_HEADER_FILE_NAME, SET_HEADER_QUESTION_TITLE } from "./HeaderTypes";

export const setHeaderQuestion = (value: any) => ({
  type: SET_HEADER_QUESTION_TITLE,
  payload: value,
});

export const setHeaderFileName = (value: any) => ({
  type: SET_HEADER_FILE_NAME,
  payload: value,
});

export const setHeaderQuestionTitle = (question: string) => {
  return async (dispatch: Dispatch) => {
    dispatch(setHeaderQuestion(question));
  };
};

export const setHeaderFileNameTitle = (fileName: string | null) => {
  return async (dispatch: Dispatch) => {
    dispatch(setHeaderFileName(fileName));
  };
};

export const setHeaderBreadcrumb = (breadcrumb: string[] | null) => ({
  type: SET_HEADER_BREADCRUMB,
  payload: breadcrumb,
});